import { render, staticRenderFns } from "./SortingList.vue?vue&type=template&id=8c29d76c"
import script from "./SortingList.vue?vue&type=script&lang=js"
export * from "./SortingList.vue?vue&type=script&lang=js"
import style0 from "./SortingList.vue?vue&type=style&index=0&id=8c29d76c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports